import { isBlankOrNullString, isString } from './stringUtils';

const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL.replace('{origin}', window.location.origin);

const orderPaths = [
    process.env.REACT_APP_API_KALA_RETRIEVE_PACKAGES_ENDPOINT,
    process.env.REACT_APP_API_KALA_STORE_ORDER_ENDPOINT
];

const loginPaths = [
    process.env.REACT_APP_API_OTP_PIN_ENDPOINT,
    process.env.REACT_APP_API_OTP_VALIDATE_PIN_ENDPOINT,
    process.env.REACT_APP_API_UPDATE_ALIAS
];

export const isOrderUrl = (path) => {
    console.log(path,'order func')
    if (path != null && isString(path)) {
        // noinspection JSMismatchedCollectionQueryUpdate
        return orderPaths.includes(path.trim());
    }
    return false;
};

export const isLoginUrl = (path) => {
    console.log(path,'login func')
    if (path != null && isString(path)) {
        // noinspection JSMismatchedCollectionQueryUpdate
        console.log(loginPaths.includes(path.trim()), 'result')
        return loginPaths.includes(path.trim());
    }
    return false;
};

const getOriginUrl = (origin, path) => {
    if (isBlankOrNullString(origin)) {
        return path;
    }
    if (origin.endsWith('/') && path?.startsWith('/')) {
        return `${origin.slice(0, -1)}${path ?? ''}`;
    }
    if (origin.endsWith('/') || path?.startsWith('/')) {
        return `${origin}${path ?? ''}`;
    }
    return `${origin}/${path ?? ''}`;
};

export const getOrderUrl = (url) => getOriginUrl(process.env.REACT_APP_ORDER_ORIGIN_URL.replace('{origin}', window.location.origin), url)
export const getLoginUrl = (url) => getOriginUrl(process.env.REACT_APP_LOGIN_ORIGIN_URL.replace('{origin}', window.location.origin), url)

export const getImageUrl = (path) => {
    if (!isString(path) || isBlankOrNullString(path)) return undefined;
    if (path.startsWith('/')) return imgBaseUrl.concat(path);
    return imgBaseUrl.concat('/').concat(path);
};

export const openNewTab = (url, shouldFocus = true) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) {
        newWindow.opener = null;
        if (shouldFocus) {
            newWindow.focus();
        }
    }
};
